import { useEffect, useState } from 'react';
  import { FormControl, FormLabel, VStack, Button, Box, Image,
  HStack, CloseButton } from '@chakra-ui/react';
  import StrongModal from '../common/StrongModal';
  import StrongInput from '../common/StrongInput';
  import StrongImageDragDrop from
  '../common/StrongImageDragDrop';

  interface EditHomeModalProps {
    selectedHome?: Home;
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (title: string, images: File[], status: string) =>
   void;
  }

  const EditHomeModal = ({ selectedHome, isOpen, onClose,
  onSubmit }: EditHomeModalProps) => {
    const [title, setTitle] = useState<string>('');
    const [status, setStatus] = useState<string>('active');
    const [imageSlots, setImageSlots] = useState<(File |
  null)[]>([null]);
    const [existingImages, setExistingImages] =
  useState<string[]>([]);

    useEffect(() => {
      setTitle(selectedHome?.title || '');
      setStatus(selectedHome?.status || 'active');
      setImageSlots([null]);
      setExistingImages(selectedHome?.images || []);
    }, [selectedHome, isOpen]);

    const handleFileSelect = (file: File | null, index: number) => {
      const updated = [...imageSlots];
      updated[index] = file;
      setImageSlots(updated);
    };

    const addImageSlot = () => {
      setImageSlots([...imageSlots, null]);
    };

    const removeImageSlot = (index: number) => {
      setImageSlots(imageSlots.filter((_, i) => i !== index));
    };

    const handleSubmit = () => {
      const files = imageSlots.filter((f): f is File => f !== null);
      onSubmit(title, files, status);
    };

    return (
      <StrongModal
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={handleSubmit}
        title={selectedHome ? 'Edit Home' : 'Create Home'}
        isSubmitDisabled={!title}
        body={
          <VStack spacing={4} align='stretch'>
            <FormControl>
              <FormLabel color='gray.600'>Title</FormLabel>
              <StrongInput
                placeholder='Enter title'
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </FormControl>

            <FormControl>
              <FormLabel color='gray.600'>Status</FormLabel>
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                style={{ width: '100%', padding: '8px',
  borderRadius: '6px', border: '1px solid #E2E8F0' }}
              >
                <option value='active'>Active</option>
                <option value='inactive'>Inactive</option>
              </select>
            </FormControl>

            {existingImages.length > 0 && (
              <FormControl>
                <FormLabel color='gray.600'>Current
  Images</FormLabel>
                <HStack spacing={2} flexWrap='wrap'>
                  {existingImages.map((url, i) => (
                    <Box key={i} position='relative' w='80px' 
  h='80px'>
                      <Image src={url} w='80px' h='80px' 
  objectFit='cover' borderRadius='md' />
                    </Box>
                  ))}
                </HStack>
              </FormControl>
            )}

            <FormControl>
              <FormLabel color='gray.600'>
                {selectedHome ? 'Replace Images (optional)' :
  'Images'}
              </FormLabel>
              {imageSlots.map((_, index) => (
                <Box key={index} mb={2} position='relative'>
                  <StrongImageDragDrop
                    onFileSelect={(file) =>
  handleFileSelect(file, index)}
                  />
                  {imageSlots.length > 1 && (
                    <CloseButton
                      position='absolute'
                      top='4px'
                      right='4px'
                      size='sm'
                      bg='whiteAlpha.800'
                      onClick={() => removeImageSlot(index)}
                    />
                  )}
                </Box>
              ))}
              <Button size='sm' variant='outline' 
  colorScheme='primary' onClick={addImageSlot} mt={1}>
                + Add Another Image
              </Button>
            </FormControl>
          </VStack>
        }
      />
    );
  };

  export default EditHomeModal;